// extracted by mini-css-extract-plugin
module.exports = {"knappIcon":"Knapp_knappIcon__Dm_Lw","knappFullWidth":"Knapp_knappFullWidth__e_uTC","lenkestyling":"Knapp_lenkestyling__SPCxp"};